let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("glTuS")).then(() => parcelRequire('clu4g'));